(() => {
  function initBeerCooler(root) {
    if (!root || root.dataset.initialized === '1') return;
    root.dataset.initialized = '1';

  const W=1235,H=2016;

  // Exact production contour based on the supplied print file.
  const PRINT_POINTS=[
    {x:215,y:10},
    {x:1019,y:10},
    {x:1228,y:520},
    {x:1228,y:2009},
    {x:6,y:2009},
    {x:6,y:520}
  ];

  // Green safety area shown in the editor.
  // The bottle mockup uses this area as its visible design crop.
  const SAFE={
    left:112,
    top:91,
    right:1122,
    bottom:1916
  };
  const $=id=>root.querySelector('[id="'+id+'"]');
  const el={
    bg:$('background'),bgHex:$('backgroundHex'),upload:$('upload'),
    text:$('text'),font:$('font'),textColor:$('textColor'),fontSize:$('fontSize'),
    addText:$('addText'),smaller:$('smaller'),larger:$('larger'),up:$('up'),
    down:$('down'),duplicate:$('duplicate'),remove:$('remove'),layers:$('layers'),
    safety:$('safety'),outline:$('outline'),
    viewport:$('viewport'),scaledBox:$('scaledBox'),stage:$('stage'),
    fit:$('fit'),zoomOut:$('zoomOut'),zoomIn:$('zoomIn'),zoomLabel:$('zoomLabel'),
    sideTitle:$('sideTitle'),
    status:$('status'),
    productPreview:$('productPreview'),mockFront:$('mockFront'),mockBack:$('mockBack'),
    mockupSideLabel:$('mockupSideLabel'),sameSides:$('sameSides'),
    designPane:$('designPane'),reviewPane:$('reviewPane'),designId:$('designId'),
    reviewFront:$('reviewFront'),reviewBack:$('reviewBack'),sameSidesSummary:$('sameSidesSummary'),
    quantity:$('quantity'),qtyMinus:$('qtyMinus'),qtyPlus:$('qtyPlus'),reviewQty:$('reviewQty'),
    reviewSides:$('reviewSides'),backToDesign:$('backToDesign'),addToCart:$('addToCart'),
    cartStatus:$('cartStatus'),reviewOrder:$('reviewOrder'),
    shopifyForm:root.querySelector('[data-bc-shopify-form]'),
    formVariant:root.querySelector('[data-bc-variant-id]'),
    formQuantity:root.querySelector('[data-bc-form-quantity]'),
    propDesignId:root.querySelector('[data-bc-prop-design-id]'),
    propSides:root.querySelector('[data-bc-prop-sides]'),
    designFileHolder:root.querySelector('[data-bc-design-file-holder]'),
    canvasEl:$('designCanvas')
  };

  if (!el.canvasEl || !window.fabric) {
    root.dataset.initialized = '0';
    return;
  }


  const canvas=new fabric.Canvas(el.canvasEl,{
    width:W,height:H,preserveObjectStacking:true,
    enableRetinaScaling:false,backgroundColor:'#ffffff'
  });

  fabric.Object.prototype.set({
    transparentCorners:false,cornerSize:18,touchCornerSize:34,
    borderColor:'#00a85a',cornerColor:'#fff',cornerStrokeColor:'#00a85a',padding:2
  });

  let side='front', mockSide='front', zoom=1;
  let sameSides=false;
  const states={front:{json:null,bg:'#ffffff'},back:{json:null,bg:'#ffffff'}};

  function active(){return canvas.getActiveObject()}
  function isText(o){return o&&['textbox','i-text','text'].includes(o.type)}

  function cloneStateData(state){
    return {
      json: state.json ? JSON.parse(JSON.stringify(state.json)) : null,
      bg: state.bg || '#ffffff'
    };
  }

  function save(){
    states[side]={json:canvas.toJSON(['name']),bg:el.bg.value};

    if(sameSides){
      // Front is the master design when both sides are identical.
      if(side==='front'){
        states.back=cloneStateData(states.front);
      }else{
        states.front=cloneStateData(states.back);
        states.back=cloneStateData(states.front);
      }
    }

    scheduleMockup();
  }

  function syncBackgroundSelection(color){
    const normalized=String(color||'').toLowerCase();
    root.querySelectorAll('[data-bg]').forEach(button=>{
      button.classList.toggle('active',String(button.dataset.bg||'').toLowerCase()===normalized);
    });
  }

  function setBackground(color,store=true){
    canvas.setBackgroundColor(color,()=>{
      canvas.requestRenderAll();
      if(store)save();
      else scheduleMockup();
    });
    el.bg.value=color;
    el.bgHex.value=color.toUpperCase();
    syncBackgroundSelection(color);
  }

  function load(target){
    save();side=target;mockSide=target;
    root.querySelectorAll('.tab').forEach(b=>b.classList.toggle('active',b.dataset.side===side));
    el.sideTitle.textContent=side==='front'?'Front':'Back';
    syncMockTabs();
    const s=states[side];

    canvas.clear();canvas.backgroundColor=s.bg||'#ffffff';
    if(s.json){
      canvas.loadFromJSON(s.json,()=>{
        canvas.backgroundColor=s.bg||'#ffffff';
        canvas.renderAll();
        el.bg.value=s.bg||'#ffffff';el.bgHex.value=(s.bg||'#ffffff').toUpperCase();syncBackgroundSelection(s.bg||'#ffffff');
        refreshLayers();scheduleMockup();
      });
    }else{
      canvas.backgroundColor=s.bg||'#ffffff';canvas.renderAll();
      el.bg.value=s.bg||'#ffffff';el.bgHex.value=(s.bg||'#ffffff').toUpperCase();syncBackgroundSelection(s.bg||'#ffffff');
      refreshLayers();scheduleMockup();
    }
  }
  function updateSameSidesUI(){
    const backTab=root.querySelector('.tab[data-side="back"]');
    if(backTab) backTab.disabled=sameSides;

    el.sameSides.checked=sameSides;
    root.querySelector('.same-sides-toggle')?.classList.toggle('is-checked',sameSides);

    // Product preview can still show Front/Back, even when identical.
    el.mockBack.disabled=false;
  }

  root.querySelectorAll('.tab').forEach(b=>b.onclick=()=>{
    if(sameSides && b.dataset.side==='back') return;
    load(b.dataset.side);
  });

  el.sameSides.onchange=()=>{
    sameSides=el.sameSides.checked;

    if(sameSides){
      // The currently visible design becomes the master.
      save();

      if(side==='back'){
        states.front=cloneStateData(states.back);
        states.back=cloneStateData(states.front);
        side='front';
      }else{
        states.back=cloneStateData(states.front);
      }

      mockSide='front';
      updateSameSidesUI();
      load('front');
      if(el.status) el.status.textContent='Front and Back are linked. Edit Front once; both sides will be identical.';
    }else{
      // Back starts as the copied design, but becomes independently editable.
      save();
      updateSameSidesUI();
      if(el.status) el.status.textContent='Front and Back can now be customized separately.';
    }
  };

  updateSameSidesUI();
  syncBackgroundSelection('#ffffff');

  function validHex(v){return /^#[0-9a-f]{6}$/i.test(v)}
  el.bg.oninput=()=>setBackground(el.bg.value);
  el.bgHex.onchange=()=>{if(validHex(el.bgHex.value))setBackground(el.bgHex.value)};
  root.querySelectorAll('[data-bg]').forEach(b=>b.onclick=()=>setBackground(b.dataset.bg));

  el.upload.onchange=e=>{
    [...e.target.files].forEach(file=>{
      const r=new FileReader();
      r.onload=ev=>fabric.Image.fromURL(ev.target.result,img=>{
        img.set({left:W/2,top:H/2,originX:'center',originY:'center',name:file.name});
        img.scale(Math.min((W*.55)/img.width,(H*.55)/img.height,1));
        canvas.add(img);canvas.setActiveObject(img);canvas.requestRenderAll();save();refreshLayers();
      });
      r.readAsDataURL(file);
    });
    e.target.value='';
  };

  el.addText.onclick=()=>{
    const value=el.text.value.trim();if(!value)return;
    const t=new fabric.Textbox(value,{
      left:W/2,top:H/2,originX:'center',originY:'center',width:W*.58,
      fontFamily:el.font.value,fontSize:Number(el.fontSize.value)||90,
      fill:el.textColor.value,textAlign:'center',name:value.split('\n')[0].slice(0,24)
    });
    canvas.add(t);canvas.setActiveObject(t);canvas.requestRenderAll();save();refreshLayers();
  };

  function scaleObject(f){
    const o=active();if(!o)return;
    o.set({scaleX:Math.max(.04,Math.min(12,(o.scaleX||1)*f)),scaleY:Math.max(.04,Math.min(12,(o.scaleY||1)*f))});
    o.setCoords();canvas.requestRenderAll();save();
  }
  el.smaller.onclick=()=>scaleObject(.85);el.larger.onclick=()=>scaleObject(1.15);
  el.up.onclick=()=>{if(active()){canvas.bringForward(active());canvas.requestRenderAll();save();refreshLayers()}};
  el.down.onclick=()=>{if(active()){canvas.sendBackwards(active());canvas.requestRenderAll();save();refreshLayers()}};
  el.remove.onclick=()=>{if(active()){canvas.remove(active());canvas.discardActiveObject();canvas.requestRenderAll();save();refreshLayers()}};
  el.duplicate.onclick=()=>{const o=active();if(!o)return;o.clone(clone=>{clone.set({left:(o.left||0)+45,top:(o.top||0)+45});canvas.add(clone);canvas.setActiveObject(clone);canvas.requestRenderAll();save();refreshLayers()})};

  el.font.onchange=()=>{const o=active();if(isText(o)){o.set('fontFamily',el.font.value);canvas.requestRenderAll();save()}};
  el.textColor.oninput=()=>{const o=active();if(isText(o)){o.set('fill',el.textColor.value);canvas.requestRenderAll();save()}};
  el.fontSize.onchange=()=>{const o=active();if(isText(o)){o.set('fontSize',Number(el.fontSize.value)||90);canvas.requestRenderAll();save()}};

  function refreshLayers(){
    const objects=canvas.getObjects(),a=active();el.layers.innerHTML='';
    [...objects].reverse().forEach(o=>{
      const b=document.createElement('button');b.type='button';b.className='layer'+(o===a?' active':'');
      b.textContent=isText(o)?'Text: '+(o.text||'').replace(/\n/g,' / ').slice(0,28):'Image: '+(o.name||'artwork');
      b.onclick=()=>{canvas.setActiveObject(o);canvas.requestRenderAll();refreshLayers()};el.layers.appendChild(b);
    });
    if(!objects.length)el.layers.innerHTML='<div class="empty">No layers yet</div>';
  }
  ['object:modified','object:added','object:removed'].forEach(evt=>canvas.on(evt,()=>{save();refreshLayers()}));
  ['selection:created','selection:updated','selection:cleared'].forEach(evt=>canvas.on(evt,refreshLayers));

  function fitScale(){const r=el.viewport.getBoundingClientRect();return Math.min((r.width-24)/W,(r.height-24)/H)}
  function renderView(){
    const scale=fitScale()*zoom;
    el.scaledBox.style.width=Math.round(W*scale)+'px';el.scaledBox.style.height=Math.round(H*scale)+'px';
    el.stage.style.transform=`scale(${scale})`;canvas.calcOffset();canvas.requestRenderAll();
    el.zoomLabel.textContent=Math.round(zoom*100)+'%';
  }
  el.fit.onclick=()=>{zoom=1;renderView()};el.zoomOut.onclick=()=>{zoom=Math.max(.6,zoom-.1);renderView()};el.zoomIn.onclick=()=>{zoom=Math.min(1.7,zoom+.1);renderView()};
  window.addEventListener('resize',renderView,{passive:true});

  if ('ResizeObserver' in window) {
    let resizeTimer;
    const observer=new ResizeObserver(()=>{
      clearTimeout(resizeTimer);
      resizeTimer=setTimeout(renderView,60);
    });
    observer.observe(el.viewport);
  }

  const bottleImage=new Image();
  bottleImage.src=root.dataset.bottlePreview;
  const bottleReady=new Promise((resolve,reject)=>{bottleImage.onload=resolve;bottleImage.onerror=reject});

  function tracePrintPath(ctx){
    ctx.beginPath();
    ctx.moveTo(PRINT_POINTS[0].x,PRINT_POINTS[0].y);
    for(let i=1;i<PRINT_POINTS.length;i++){
      ctx.lineTo(PRINT_POINTS[i].x,PRINT_POINTS[i].y);
    }
    ctx.closePath();
  }

  async function renderRawSide(target){
    // When linked, both production sides always resolve to the Front master.
    if(sameSides) target='front';

    const s=target===side
      ? {json:canvas.toJSON(['name']),bg:el.bg.value}
      : states[target];

    const raw=document.createElement('canvas');
    raw.width=W;
    raw.height=H;

    const fc=new fabric.StaticCanvas(raw,{
      width:W,
      height:H,
      enableRetinaScaling:false,
      backgroundColor:s.bg||'#ffffff'
    });

    if(s.json){
      await new Promise(resolve=>{
        fc.loadFromJSON(s.json,()=>{
          fc.backgroundColor=s.bg||'#ffffff';
          fc.renderAll();
          resolve();
        });
      });
    }else{
      fc.renderAll();
    }

    return {raw,fc};
  }

  async function renderSide(target){
    const rendered=await renderRawSide(target);

    // Final production canvas is transparent outside the exact print contour.
    const finalCanvas=document.createElement('canvas');
    finalCanvas.width=W;
    finalCanvas.height=H;

    const ctx=finalCanvas.getContext('2d');

    ctx.save();
    tracePrintPath(ctx);
    ctx.clip();
    ctx.drawImage(rendered.raw,0,0);
    ctx.restore();

    return {
      canvas:finalCanvas,
      fc:rendered.fc
    };
  }

  let mockTimer;
  function scheduleMockup(){clearTimeout(mockTimer);mockTimer=setTimeout(renderMockup,80)}

  function syncMockTabs(){
    el.mockFront.classList.toggle('active',mockSide==='front');
    el.mockBack.classList.toggle('active',mockSide==='back');
    el.mockupSideLabel.textContent=mockSide==='front'?'Front':'Back';
  }

  el.mockFront.onclick=()=>{mockSide='front';syncMockTabs();renderMockup()};
  el.mockBack.onclick=()=>{
    mockSide='back';
    syncMockTabs();
    renderMockup();
  };

  async function renderMockup(){
    try{
      await bottleReady;
      const rendered=await renderSide(mockSide);
      const p=el.productPreview,ctx=p.getContext('2d');
      p.width=800;p.height=800;ctx.clearRect(0,0,800,800);

      // Base product photo.
      ctx.drawImage(bottleImage,0,0,800,800);

      // Sleeve area on the supplied product photo.
      ctx.save();
      ctx.beginPath();

      // Printable visible sleeve area.
      // This starts BELOW the upper black stitched seam and ends ABOVE
      // the lower black stitched seam, so both stitched bands stay visible.
      ctx.moveTo(318,302);
      ctx.lineTo(467,302);

      // upper shoulders - start directly under the stitched top band
      ctx.quadraticCurveTo(477,320,485,342);
      ctx.quadraticCurveTo(493,364,497,386);

      // right body
      ctx.lineTo(497,690);

      // rounded lower right
      ctx.quadraticCurveTo(497,711,488,725);
      ctx.quadraticCurveTo(477,739,455,746);

      // curved printable bottom, above the stitched band
      ctx.quadraticCurveTo(426,754,393,754);
      ctx.quadraticCurveTo(360,754,329,746);

      // rounded lower left
      ctx.quadraticCurveTo(307,739,298,725);
      ctx.quadraticCurveTo(289,711,289,690);

      // left body
      ctx.lineTo(289,388);

      // upper left shoulder - start directly under the stitched top band
      ctx.quadraticCurveTo(295,364,303,342);
      ctx.quadraticCurveTo(310,320,318,302);

      ctx.closePath();
      ctx.clip();

      // Only the artwork inside the GREEN SAFETY AREA is shown on the bottle.
      // This means the left/right mockup visibility stops at the safety margin.
      const safeW=SAFE.right-SAFE.left;
      const safeH=SAFE.bottom-SAFE.top;

      // Map the complete safe zone onto the complete visible sleeve.
      // The previous version placed it slightly beyond the top/bottom overlay,
      // which hid content close to the upper and lower green safety lines.
      //
      // These destination coordinates keep the FULL safe area readable:
      // top green line -> just below the black neck seam
      // bottom green line -> just above the black bottom seam
      const sleeveLeft=289;
      const sleeveTop=298;
      const sleeveWidth=208;
      const sleeveHeight=456;

      ctx.drawImage(
        rendered.canvas,
        SAFE.left,SAFE.top,safeW,safeH,
        sleeveLeft,sleeveTop,sleeveWidth,sleeveHeight
      );
      ctx.restore();

      // Redraw product top/bottom details above the artwork for realism.
      // Repaint the real upper stitched band and neck OVER the artwork.
      // This guarantees the black stitched seam always remains visible.
      ctx.save();
      ctx.beginPath();
      ctx.rect(0,0,800,310);
      ctx.clip();
      ctx.drawImage(bottleImage,0,0,800,800);
      ctx.restore();

      // Repaint the real curved lower stitched band OVER the artwork.
      ctx.save();
      ctx.beginPath();
      ctx.rect(0,746,800,54);
      ctx.clip();
      ctx.drawImage(bottleImage,0,0,800,800);
      ctx.restore();

      rendered.fc.dispose();
    }catch(err){console.error('Mockup preview failed',err)}
  }

  async function download(target){
    save();
    el.status.textContent='Preparing '+target+' print file…';

    try{
      const result=await renderSide(target);

      const blob=await new Promise((resolve,reject)=>{
        result.canvas.toBlob(
          b=>b?resolve(b):reject(new Error('Could not create PNG file')),
          'image/png'
        );
      });

      const url=URL.createObjectURL(blob);
      const a=document.createElement('a');

      a.href=url;
      a.download=`beer-cooler-${target}-1235x2016.png`;

      document.body.appendChild(a);
      a.click();
      a.remove();

      setTimeout(()=>URL.revokeObjectURL(url),1500);

      result.fc.dispose();

      el.status.textContent=
        'Downloaded successfully. Outside the print shape is transparent and guides are excluded.';
    }catch(err){
      console.error(err);
      el.status.textContent='Export failed: '+err.message;
    }
  }




  function makeDesignId(){
    const chars='ABCDEFGHJKLMNPQRSTUVWXYZ23456789';
    let code='BC-';
    for(let i=0;i<10;i++) code+=chars[Math.floor(Math.random()*chars.length)];
    return code;
  }

  let designId=makeDesignId();

  function setFlowStep(step){
    root.querySelectorAll('[data-flow-step]').forEach(b=>{
      b.classList.toggle('active',b.dataset.flowStep===step);
    });
    el.designPane.classList.toggle('active',step==='design');
    el.reviewPane.classList.toggle('active',step==='review');
    if(step==='review') buildReview();
  }

  root.querySelectorAll('[data-flow-step]').forEach(b=>{
    b.onclick=()=>setFlowStep(b.dataset.flowStep);
  });

  el.backToDesign.onclick=()=>setFlowStep('design');
  if(el.reviewOrder) el.reviewOrder.onclick=()=>setFlowStep('review');

  function drawReviewCanvas(targetCanvas,sourceCanvas){
    const ctx=targetCanvas.getContext('2d');
    ctx.clearRect(0,0,targetCanvas.width,targetCanvas.height);
    ctx.drawImage(sourceCanvas,0,0,sourceCanvas.width,sourceCanvas.height,0,0,targetCanvas.width,targetCanvas.height);
  }

  async function buildReview(){
    save();
    if(el.designId) el.designId.textContent=designId;

    const front=await renderSide('front');
    const back=await renderSide(sameSides?'front':'back');

    drawReviewCanvas(el.reviewFront,front.canvas);
    drawReviewCanvas(el.reviewBack,back.canvas);

    front.fc.dispose();
    back.fc.dispose();

    if(el.sameSidesSummary){
      el.sameSidesSummary.textContent=sameSides
        ? 'Front = Back ✓ Same design on both sides.'
        : 'Front and Back use separate designs.';
    }

    if(el.reviewSides) el.reviewSides.textContent=sameSides?'Front = Back':'Front + Back';
    syncQuantity();
  }

  function syncQuantity(){
    const q=Math.max(1,Math.round(Number(el.quantity?.value)||1));
    if(el.quantity) el.quantity.value=q;
    if(el.reviewQty) el.reviewQty.textContent=String(q);
    return q;
  }

  if(el.quantity) el.quantity.onchange=syncQuantity;
  if(el.qtyMinus) el.qtyMinus.onclick=()=>{
    if(el.quantity) el.quantity.value=Math.max(1,syncQuantity()-1);
    syncQuantity();
  };
  if(el.qtyPlus) el.qtyPlus.onclick=()=>{
    if(el.quantity) el.quantity.value=syncQuantity()+1;
    syncQuantity();
  };



  function setCartStatus(message){
    if(el.cartStatus) el.cartStatus.textContent=message;
  }

  function canvasToPngBlob(canvasEl){
    return new Promise((resolve,reject)=>{
      try{
        // Force PNG encoding explicitly. We do not rely on Shopify/browser
        // choosing the image format for us.
        const dataUrl=canvasEl.toDataURL('image/png',1.0);

        if(!dataUrl || !dataUrl.startsWith('data:image/png;base64,')){
          throw new Error('The production file was not encoded as PNG.');
        }

        const base64=dataUrl.split(',')[1];
        const binary=atob(base64);
        const bytes=new Uint8Array(binary.length);

        for(let i=0;i<binary.length;i++){
          bytes[i]=binary.charCodeAt(i);
        }

        const blob=new Blob([bytes],{type:'image/png'});

        // PNG signature: 89 50 4E 47 0D 0A 1A 0A
        blob.slice(0,8).arrayBuffer().then(buffer=>{
          const sig=new Uint8Array(buffer);
          const valid=
            sig.length===8 &&
            sig[0]===0x89 && sig[1]===0x50 && sig[2]===0x4e && sig[3]===0x47 &&
            sig[4]===0x0d && sig[5]===0x0a && sig[6]===0x1a && sig[7]===0x0a;

          if(!valid){
            reject(new Error('PNG validation failed.'));
            return;
          }

          resolve(blob);
        }).catch(reject);
      }catch(err){
        reject(err);
      }
    });
  }


  async function createProductionFiles(){
    setCartStatus('Preparing production PNG file(s)…');
    const front=await renderSide('front');
    let back=null;
    try{
      const frontBlob=await canvasToPngBlob(front.canvas);
      const files={
        front:new File([frontBlob],`${designId}-front.PNG`,{type:'image/png',lastModified:Date.now()}),
        back:null
      };
      if(!sameSides){
        back=await renderSide('back');
        const backBlob=await canvasToPngBlob(back.canvas);
        files.back=new File([backBlob],`${designId}-back.PNG`,{type:'image/png',lastModified:Date.now()});
      }
      return files;
    }finally{
      front.fc.dispose();
      if(back) back.fc.dispose();
    }
  }

  function attachGeneratedFile(propertyName,file){
    if(typeof DataTransfer==='undefined'){
      throw new Error('This browser cannot attach the generated design file. Please try another browser.');
    }

    if(!(file instanceof File) || file.type!=='image/png' || !/\.png$/i.test(file.name)){
      throw new Error('Production artwork must be a PNG file.');
    }

    const input=document.createElement('input');
    input.type='file';
    input.accept='image/png,.png';
    input.name=`properties[${propertyName}]`;
    input.hidden=true;

    const transfer=new DataTransfer();
    transfer.items.add(file);
    input.files=transfer.files;

    if(!input.files[0] || input.files[0].type!=='image/png'){
      throw new Error('Browser did not preserve the PNG production file.');
    }

    el.designFileHolder.appendChild(input);
  }

  function currentVariantId(){
    // The hidden Beer Cooler order form already contains Shopify's
    // selected_or_first_available_variant. Use that as the reliable fallback.
    const fallback=String(el.formVariant?.value || root.dataset.variantId || '').trim();

    // If the product template has a live variant selector, prefer its current value.
    const section=root.closest('.shopify-section') || root.closest('section') || document;
    const candidates=[
      ...section.querySelectorAll('form[action*="/cart/add"] input[name="id"], form[action*="/cart/add"] select[name="id"]')
    ];

    for(const field of candidates){
      // Do not read our own hidden order form back as the "external" selector.
      if(field===el.formVariant) continue;

      const value=String(field.value || '').trim();
      if(/^\d+$/.test(value)) return value;
    }

    return /^\d+$/.test(fallback) ? fallback : null;
  }

  function prepareShopifyForm(files){
    if(!el.shopifyForm || !el.designFileHolder || !el.formVariant || !el.formQuantity){
      throw new Error('Shopify order form is incomplete on this page.');
    }

    const variantId=currentVariantId();
    if(!variantId){
      throw new Error('No Shopify variant was found for this Beer Cooler product.');
    }

    el.designFileHolder.innerHTML='';

    el.formVariant.value=variantId;
    el.formQuantity.value=String(syncQuantity());
    el.propDesignId.value=designId;
    el.propSides.value=sameSides?'Same design':'Different designs';

    attachGeneratedFile(
      sameSides ? 'Production design PNG (Front + Back same)' : 'Front production PNG',
      files.front
    );
    if(files.back) attachGeneratedFile('Back production PNG',files.back);
  }

  if(el.addToCart){
    el.addToCart.onclick=async()=>{
      const originalText=el.addToCart.textContent;

      el.addToCart.disabled=true;
      el.addToCart.setAttribute('aria-busy','true');
      el.addToCart.textContent='Preparing design…';
      setCartStatus('Preparing your custom Beer Cooler…');

      try{
        save();

        const files=await createProductionFiles();

        el.addToCart.textContent='Adding to cart…';
        prepareShopifyForm(files);

        setCartStatus('Uploading production PNG file(s) and adding product to cart…');

        // Same proven native multipart form mechanism used by the Bar Mat customizer.
        // The browser navigates to Shopify after this call.
        el.shopifyForm.submit();

      }catch(err){
        console.error('Beer Cooler add-to-cart failed:',err);
        setCartStatus('Could not add to cart: '+(err?.message || 'Unknown error'));
        el.addToCart.disabled=false;
        el.addToCart.removeAttribute('aria-busy');
        el.addToCart.textContent=originalText;
      }
    };
  }

  states.front={json:canvas.toJSON(['name']),bg:'#ffffff'};
  states.back=cloneStateData(states.front);
  requestAnimationFrame(()=>{
    updateSameSidesUI();
    renderView();
    refreshLayers();
    canvas.requestRenderAll();
    syncMockTabs();
    scheduleMockup();

    setTimeout(renderView,120);
    setTimeout(renderView,350);
  });
  }

  function boot() {
    if (!window.fabric) {
      setTimeout(boot,80);
      return;
    }
    document.querySelectorAll('[data-beer-cooler-app]').forEach(initBeerCooler);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll?.('[data-beer-cooler-app]').forEach(initBeerCooler);
  });
})();
